import { type StoreGroupsFormProps } from '../../form/StoreGroupsForm'
import { useCreateStoreGroup } from '../../../graphql/create.hooks'

export const useCreateStoreGroupOnSubmit = () => {
  const { createStoreGroup, createdStoreGroup, loading, error } = useCreateStoreGroup()

  const handleSubmit: StoreGroupsFormProps['handleSubmit'] = ({
    name,
    selectedLocationIds: retailerLocationIds,
  }) => {
    createStoreGroup({
      name,
      retailerLocationIds,
    })
  }

  return {
    handleSubmit,
    createdStoreGroup,
    loading,
    error,
  }
}
